const e = {
  terms: {
    bancontact: "never",
    card: "never",
    ideal: "never",
    klarna: "never"
  }
};
export {
  e as hiddenStripePaymentElementTermsOptions
};
